function PageLoading() {
  return (
    <div className="loader-overlay" aria-busy="true">
      <div className="ui-spinner" role="status" />
      <span className="visually-hidden">Загрузка...</span>
    </div>
  );
}

export default PageLoading;
